import { render, staticRenderFns } from "./TagsCategoryShareModal.vue?vue&type=template&id=3a816ec6&scoped=true"
import script from "./TagsCategoryShareModal.vue?vue&type=script&lang=js"
export * from "./TagsCategoryShareModal.vue?vue&type=script&lang=js"
import style0 from "./TagsCategoryShareModal.vue?vue&type=style&index=0&id=3a816ec6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a816ec6",
  null
  
)

export default component.exports